// Юридические и справочные тексты MAX Магазина. Источник правды для публикуемых
// страниц. Места, помеченные lawyerNote, требуют проверки практикующего юриста РФ
// перед боевым использованием. Реквизиты ИП заполнены (Жуйков А.Ю.).
//
// Тире – только en dash (–). Без атрибуции инструментов.

export interface LegalSection {
  h: string;
  body: string[];
}

export interface LegalDoc {
  slug: string;
  title: string;
  updated: string;
  intro?: string;
  sections: LegalSection[];
  lawyerNote?: boolean;
}

const OFFER: LegalDoc = {
  slug: 'offer',
  title: 'Договор-оферта на использование сервиса',
  updated: '2026-06-20',
  lawyerNote: true,
  intro:
    'Настоящий документ – публичная оферта. Регистрируясь и используя сервис MAX Магазин, ' +
    'продавец (далее – Пользователь) принимает условия в полном объёме.',
  sections: [
    {
      h: '1. Термины',
      body: [
        'Сервис – программное обеспечение MAX Магазин для создания и ведения интернет-витрины ' +
          'в мессенджере MAX и в браузере, доступное по адресу max.cyberdub.su.',
        'Исполнитель – Индивидуальный предприниматель Жуйков Алексей Юрьевич, ' +
          'ИНН 781600785722, ОГРНИП 325784700428590, ' +
          'адрес: г. Санкт-Петербург, ул. Будапештская, д. 3, корп. 2, литера А, кв. 227, ' +
          'e-mail alexey.zhuykov@gmail.com, телефон +7 (921) 946-85-35.',
        'Пользователь – физическое лицо, ИП или организация, использующие Сервис для продажи ' +
          'собственных товаров.',
      ],
    },
    {
      h: '2. Предмет',
      body: [
        'Исполнитель предоставляет Пользователю право использования Сервиса на условиях ' +
          'подписки. Сервис – инструмент-витрина: Исполнитель не является продавцом товаров ' +
          'Пользователя и стороной сделок между Пользователем и его покупателями.',
        'Ответственность за товар, его качество, доставку, расчёты с покупателями и ' +
          'соблюдение прав потребителей несёт Пользователь.',
      ],
    },
    {
      h: '3. Тариф и оплата',
      body: [
        'Стоимость подписки – 1490 рублей в месяц. Первые 14 дней предоставляются бесплатно ' +
          '(пробный период).',
        'По окончании пробного периода доступ сохраняется при оформлении подписки. Оплата ' +
          'производится банковской картой через платёжный сервис ЮKassa; кассовый чек ' +
          'формируется в соответствии с 54-ФЗ.',
        'Подписка продлевается автоматически ежемесячным списанием с сохранённой карты. ' +
          'Уведомление о предстоящем списании направляется не позднее чем за 3 дня.',
      ],
    },
    {
      h: '4. Права и обязанности',
      body: [
        'Пользователь обязуется размещать только товары, оборот которых не запрещён ' +
          'законодательством РФ, и не нарушать прав третьих лиц.',
        'Исполнитель обеспечивает работоспособность Сервиса и вправе проводить технические ' +
          'работы с предварительным уведомлением при существенных перерывах.',
      ],
    },
    {
      h: '5. Отмена и возврат',
      body: [
        'Пользователь вправе отменить подписку в любой момент в кабинете. Доступ сохраняется ' +
          'до конца оплаченного периода. Порядок возврата – в Политике возвратов.',
      ],
    },
    {
      h: '6. Ответственность',
      body: [
        'Сервис предоставляется на условиях «как есть». Исполнитель не отвечает за упущенную ' +
          'выгоду Пользователя и за действия покупателей.',
      ],
    },
    {
      h: '7. Реквизиты Исполнителя',
      body: [
        'Индивидуальный предприниматель Жуйков Алексей Юрьевич, ИНН 781600785722, ОГРНИП 325784700428590, e-mail alexey.zhuykov@gmail.com.',
      ],
    },
  ],
};

const PRIVACY: LegalDoc = {
  slug: 'privacy',
  title: 'Политика обработки персональных данных',
  updated: '2026-06-20',
  lawyerNote: true,
  intro:
    'Политика описывает обработку персональных данных в Сервисе MAX Магазин в соответствии ' +
    'с Федеральным законом № 152-ФЗ «О персональных данных».',
  sections: [
    {
      h: '1. Оператор',
      body: ['Оператор – Индивидуальный предприниматель Жуйков Алексей Юрьевич, ИНН 781600785722, ОГРНИП 325784700428590, e-mail alexey.zhuykov@gmail.com.'],
    },
    {
      h: '2. Состав данных',
      body: [
        'Продавцы: идентификатор в мессенджере MAX, имя/название магазина, контактные данные ' +
          'для уведомлений.',
        'Покупатели: имя, телефон, адрес доставки – в объёме, необходимом для оформления и ' +
          'исполнения заказа у конкретного продавца.',
      ],
    },
    {
      h: '3. Цели и основания',
      body: [
        'Цели – предоставление доступа к Сервису, оформление заказов, расчёты и уведомления. ' +
          'Основания – исполнение договора (оферты) и согласие субъекта.',
      ],
    },
    {
      h: '4. Передача третьим лицам',
      body: [
        'Платёжные данные обрабатывает ЮKassa (АО «ЮMoney») как самостоятельный оператор при ' +
          'проведении оплаты. Данные покупателей передаются продавцу, у которого оформлен заказ, ' +
          'для его исполнения.',
        'Данные не передаются иным лицам, кроме случаев, предусмотренных законом.',
      ],
    },
    {
      h: '5. Хранение и защита',
      body: [
        'Данные хранятся на серверах в РФ в течение срока, необходимого для целей обработки, и ' +
          'удаляются по их достижении. Применяются организационные и технические меры защиты.',
      ],
    },
    {
      h: '6. Права субъекта',
      body: [
        'Субъект вправе запросить доступ, уточнение, удаление своих данных и отзыв согласия, ' +
          'направив обращение на alexey.zhuykov@gmail.com.',
      ],
    },
  ],
};

const RETURNS: LegalDoc = {
  slug: 'returns',
  title: 'Политика возвратов',
  updated: '2026-06-20',
  lawyerNote: true,
  intro: 'Политика разделяет возврат за подписку на Сервис и возврат за товары продавцов.',
  sections: [
    {
      h: '1. Подписка на Сервис',
      body: [
        'Пробный период – бесплатный, списаний в нём нет. После оформления подписки возврат за ' +
          'неиспользованный остаток оплаченного периода производится по запросу на alexey.zhuykov@gmail.com ' +
          'и рассматривается в течение 10 рабочих дней.',
        'Отмена подписки прекращает дальнейшие списания; доступ сохраняется до конца ' +
          'оплаченного периода.',
      ],
    },
    {
      h: '2. Товары продавцов',
      body: [
        'Сервис – витрина, а не продавец товаров. Возврат и обмен товаров регулируются ' +
          'продавцом, у которого оформлен заказ, в соответствии с Законом «О защите прав ' +
          'потребителей». Претензии по товару направляются продавцу.',
      ],
    },
    {
      h: '3. Возврат платежа',
      body: [
        'Возвраты по оплатам проводятся через ЮKassa на тот же способ оплаты, которым была ' +
          'произведена покупка.',
      ],
    },
  ],
};

const FAQ: LegalDoc = {
  slug: 'faq',
  title: 'Частые вопросы',
  updated: '2026-06-20',
  sections: [
    {
      h: 'Для продавца',
      body: [
        'Что это? – Конструктор магазина в мессенджере MAX и в браузере: витрина, корзина, ' +
          'приём заказов и оплата.',
        'Сколько стоит? – 1490 рублей в месяц, первые 14 дней бесплатно. Отмена в любой момент.',
        'Как принимать оплату? – Оплата картой через ЮKassa, чек по 54-ФЗ формируется автоматически.',
        'Можно перенести товары с WildBerries или Ozon? – Да, импорт по официальному токену ' +
          'продавца (Seller API), без передачи логина и пароля.',
        'Как узнаю о заказе? – Уведомление приходит в Telegram в течение пары секунд после заказа.',
      ],
    },
    {
      h: 'Для покупателя',
      body: [
        'Как оформить заказ? – Добавьте товары в корзину, укажите имя и контакты, подтвердите заказ.',
        'Безопасна ли оплата? – Оплата проходит через ЮKassa; данные карты Сервису не передаются.',
        'Как отследить заказ? – По ссылке «Отслеживать заказ», которая появляется после оформления.',
      ],
    },
  ],
};

const GUIDE: LegalDoc = {
  slug: 'guide',
  title: 'Магазин за 5 минут',
  updated: '2026-06-20',
  intro: 'Пять шагов от регистрации до готовой витрины, которой можно делиться.',
  sections: [
    { h: 'Шаг 1. Войдите', body: ['Откройте MAX Магазин и войдите – авторизация через MAX, без паролей.'] },
    { h: 'Шаг 2. Назовите магазин', body: ['Укажите название, слоган и фирменный цвет. Это займёт минуту.'] },
    {
      h: 'Шаг 3. Добавьте товар',
      body: ['Добавьте первый товар: фото, цена. Описание и фон фото можно улучшить автоматически. ' +
        'Есть каталог на WildBerries или Ozon – импортируйте его по токену продавца.'],
    },
    {
      h: 'Шаг 4. Подключите оплату и уведомления',
      body: ['Привяжите Telegram, чтобы получать заказы мгновенно. Оплата картой через ЮKassa ' +
        'включается после идентификации в кабинете ЮKassa.'],
    },
    {
      h: 'Шаг 5. Поделитесь витриной',
      body: ['Скопируйте ссылку или QR-код на вкладке «Дизайн» и отправьте своим покупателям ' +
        'в MAX, Telegram или ВКонтакте. Заказы начнут приходить в кабинет.'],
    },
  ],
};

export const LEGAL_DOCS: Record<string, LegalDoc> = {
  offer: OFFER,
  privacy: PRIVACY,
  returns: RETURNS,
  faq: FAQ,
  guide: GUIDE,
};

export const LEGAL_LINKS: { slug: string; label: string }[] = [
  { slug: 'guide', label: 'Магазин за 5 минут' },
  { slug: 'faq', label: 'Частые вопросы' },
  { slug: 'offer', label: 'Оферта' },
  { slug: 'returns', label: 'Возвраты' },
  { slug: 'privacy', label: 'Персональные данные' },
];
